import { FaCircle } from 'react-icons/fa';
import styled, { css } from 'styled-components';

import {
  mobile,
  OverallFitSlider as BaseOverallFitSlider,
  ReviewsDrawer as BaseReviewsDrawer,
} from '~/techstyle-shared/react-components';

import {
  inputSizeStyle as genericInputSizeStyle,
  itemSizeLabelStyle as genericItemSizeLabelStyle,
} from '../../../styles/genericSelectorStyles';

export const SortFilterDrawer = styled(BaseReviewsDrawer)`
  left: auto;
  right: 0;
  bottom: 0;
`;

export const DrawerContentWrapper = styled.div`
  padding: 16px;
  right: 0;
  bottom: 0;
`;

export const FilterButton = styled.button`
  ${({ theme }) => theme.reviewsFiltersStyles.filterAndSortButton}
`;

export const FilterButtonLabel = styled.span`
  padding: 0 4px;
`;

export const showMoreButtonStyle = css`
  font-family: ${({ theme }) => theme.fontStacks.baseFamily};
`;

export const blockStyle = css`
  padding: 32px 16px;
  ${({ theme }) => theme.recentReviewsStyle.blockStyle};

  &:first-of-type {
    border-radius: 3px 3px 0 0;
  }

  &:last-of-type {
    border-radius: 0 0 3px 3px;
  }

  ${mobile`
    padding: 16px;
  `}
`;

export const reviewsFiltersStyles = {
  sectionTitleStyle: css`
    letter-spacing: -0.4px;
    line-height: 1.5;
    color: ${({ theme }) => theme.colors.drawerReviewsFilters};
  `,
  sectionTitleSelectedItemsStyle: css`
    letter-spacing: -0.4px;
    color: ${({ theme }) => theme.colors.sublabelBlack};
  `,
  radioItemLabelStyle: css`
    letter-spacing: -0.4px;
    color: ${({ theme }) => theme.colors.sublabelBlack};
  `,
  applyButtonStyle: css`
    ${({ theme: { reviewsFiltersStyles } }) =>
      reviewsFiltersStyles.applyButtonStyle}
  `,
  clearAllButtonStyle: css`
    ${({ theme: { reviewsFiltersStyles } }) =>
      reviewsFiltersStyles.clearAllButtonStyle}
  `,
};

export const inputOtherStyle = css`
  ${genericInputSizeStyle}
  height: 40px;
  width: 151px;
`;

export const inputSizeStyle = css`
  ${genericInputSizeStyle}
  width: 72px;
  height: 40px;

  ${mobile`
      width: 74px;
  `}
`;

export const RowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ResultCount = styled.span`
  display: flex;
  font-size: 14px;
  align-self: center;
  color: ${({ theme }) => theme.colors.drawerStyleResultCount};
`;

export const itemSizeLabelStyle = css`
  ${genericItemSizeLabelStyle}
  text-transform: none;
`;

export const ScrollWrapper = styled.div`
  padding-bottom: 10px;
`;

export const FilterActiveDot = styled(FaCircle)`
  font-size: 8px;
  color: ${({ theme }) => theme.colors.selectedFilterColor};
`;

export const FilterCount = styled.span`
  color: ${({ theme }) => theme.colors.reviewsDrawerFilterCount};
  position: relative;
  margin-right: 8px;

  ${FilterActiveDot} {
    position: absolute;
    top: 0;
  }
`;

export const OverallFitSlider = styled(BaseOverallFitSlider)`
  padding: 0 16px;
`;

export const overallFitStyle = css`
  font-weight: bold;
  width: 100%;
  margin-top: 16px;
`;

export const separatorStyle = css`
  margin: 32px 0 0;
`;
